import { useEffect, useState } from "react";
import axios from "axios";
import { Box, CircularProgress } from "@mui/material";
import LandingPage from "./LandingPage";
import SchoolPublicPage from "./public/SchoolPublicPage";
import { getApiBaseUrl } from "../config/api";
import { usePlatformHomeSchoolOnApex } from "../config/platformHost";

/**
 * Apex `/`: Maphunziro marketing landing.
 * With school subdomains enabled, each school lives at {slug}.PLATFORM_HOST (not on `/`).
 * Optional “platform home” school on `/` only on custom domain + path mode (not Netlify preview).
 */
export default function Homepage() {
    const allowPlatformHomeSchool = usePlatformHomeSchoolOnApex();

    if (!allowPlatformHomeSchool) {
        return <LandingPage />;
    }

    return <HomepageWithOptionalSchool />;
}

function HomepageWithOptionalSchool() {
    const [platformSchoolId, setPlatformSchoolId] = useState(undefined);

    useEffect(() => {
        let cancelled = false;
        axios
            .get(`${getApiBaseUrl()}/PublicPlatformHome`)
            .then((res) => {
                if (!cancelled) setPlatformSchoolId(res.data?.schoolId ?? null);
            })
            .catch(() => {
                if (!cancelled) setPlatformSchoolId(null);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    if (platformSchoolId === undefined) {
        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#0a0b1a",
                }}
            >
                <CircularProgress sx={{ color: "#ff7a00" }} />
            </Box>
        );
    }

    if (platformSchoolId) {
        return <SchoolPublicPage schoolIdProp={platformSchoolId} isRootPlatformHome />;
    }

    return <LandingPage />;
}
